import * as moment from "moment";
import { defineComponent } from "vue";

export enum ItemKind {
    HELLO = 'hello',
    INFO = 'info',
    MESSAGE = 'message',
}

export interface AbstractChatItem {
    kind: string;
    date: Date;
}

export interface Action {
    id: string;
    name: string;
}

export default defineComponent({
    template: `
        <div class="ChatItem" :class="{ 'ChatItem--waiting': waiting }, 'ChatItem--' + kind">
            <div class="ChatItem__inner">
                <div class="ChatItem__author" v-if="author">{{ author }}</div>

                <div class="ChatItem__body">
                    <div v-if="waiting" class="ChatItem__loader"></div>

                    <div v-if="content" class="ChatItem__content" v-html="content"></div>

                    <div v-else class="ChatItem__content">
                        <slot></slot>
                    </div>
                </div>

                <div v-if="date" class="ChatItem__date">{{ formattedTime }}</div>

                <div v-if="controls" class="ChatItem__controls">
                    <slot name="controls"></slot>

                    <button v-if="actions?.length" type="button" title="Akcje" @click="visible_actions = !visible_actions"><i class="fa fa-ellipsis-v"></i></button>

                    <div class="ChatItem__actions" v-if="visible_actions">
                        <button v-for="action in actions" type="button" @click="onAction(action)">{{ action.name }}</button>
                    </div>
                </div>
            </div>
        </div>
    `,

    emits: [
        'action',
    ],

    props: {
        kind: { type: String, required: true },
        author: { type: String },
        date: { type: Date },
        content: { type: String },
        waiting: { type: Boolean },
        controls: { type: Boolean },
        actions: { type: Array },
    },

    data() {
        return {
            visible_actions: false,
        };
    },

    computed: {
        formattedTime() {
            return moment(this.date).format('HH:mm');
        },
    },

    methods: {
        onAction(action: Action) {
            this.visible_actions = false;

            this.$emit('action', action.id);
        },
    },
});
